import { _ as s } from "./index817.mjs";
import { _ as o } from "./index818.mjs";
import { _ as r } from "./index819.mjs";
import { _ } from "./index820.mjs";
import { _ as p } from "./index821.mjs";
import { _ as c } from "./index822.mjs";
var i = s, k = o, m = r, f = _, l = p, h = c;
function t(a) {
  var e = this.__data__ = new i(a);
  this.size = e.size;
}
t.prototype.clear = k;
t.prototype.delete = m;
t.prototype.get = f;
t.prototype.has = l;
t.prototype.set = h;
var z = t;
export {
  z as _
};
